const data = [
    { id: 4, name: "Professor" },
    { id: 5, name: "Monitor" },
    { id: 6, name: "Coordenador" },
    { id: 9, name: "Colaborador" },
];
    
export default [...data];
